import { Switch, SwitchLabel } from '@latitude/switch';
import { FormComponentWrapper } from 'components/FormComponentWrapper';
import noop from 'lodash.noop';
import type { FieldValues } from 'react-hook-form';
import { Controller } from 'react-hook-form';

import type { FormSwitchProps } from './types';

export const FormSwitch = <T extends FieldValues = FieldValues>({
  name,
  control,
  description,
  label,
  wrapperClassname,
  disabled,
  message,
  optional,
  size,
  rules,
  onBlur: passedOnBlur = noop,
  onChange: passedOnChange,
  ...switchProps
}: FormSwitchProps<T>) => {
  return (
    <Controller
      name={name}
      {...(control
        ? { control }
        : {
            // if undefined, Controller reads from FormProvider
          })}
      rules={rules}
      render={({
        field: { onBlur, onChange, value },
        fieldState: { error },
      }) => (
        <FormComponentWrapper
          name={name}
          description={description}
          error={error}
          className={wrapperClassname}
          message={message}
          optional={optional}
          disabled={disabled}
        >
          <div className="flex items-center gap-2">
            <Switch
              disabled={disabled}
              checked={value}
              onBlur={(event) => {
                onBlur();
                passedOnBlur(event);
              }}
              onCheckedChange={(checked) => {
                if (passedOnChange) {
                  passedOnChange(checked, onChange);
                } else {
                  onChange(checked);
                }
              }}
              id={name}
              size={size}
              {...switchProps}
            />
            <SwitchLabel size={size} htmlFor={name}>
              {label}
            </SwitchLabel>
          </div>
        </FormComponentWrapper>
      )}
    />
  );
};
